module.exports = __webpack_public_path__ + "static/media/arrow-down.25dfd2b9.svg";